import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, withWidth} from '@material-ui/core';
import {isWidthUp} from "@material-ui/core/withWidth";
import {Fade} from 'react-reveal';

const imagePath = '/images/investments.svg';
const styles = theme => ({
  root: {
    backgroundColor: theme.palette.secondary.light,
    padding: theme.spacing.unit * 12,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 8,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    paddingBottom: theme.spacing.unit * 2
  },
  image: {
    maxWidth: '100%'
  },
  icon: {
    height: 40,
    width: 40
  },
  cardsContainer: {
    paddingTop: theme.spacing.unit * 4
  },
  card: {
    padding: theme.spacing.unit * 3,
    backgroundColor: theme.palette.primary.lighter,
    height: '100%'
  },
  cardTitle: {
    paddingBottom: theme.spacing.unit * 2,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.primary.light
  },
  cardDescription: {
    color: theme.palette.text.secondary
  },
  bottomTextContainer: {
    paddingTop: theme.spacing.unit * 6
  }
});


const Investments = withStyles(styles)(({classes, width}) => (
  <div className={classes.root}>
    <Grid container direction="column" justify="space-evenly" alignItems="center">
      <Fade bottom duration={1500} cascade={true} distance="100px">
        {/* Name */}
        <Grid item>
          <Typography variant="caption" color="secondary" gutterBottom className={classes.tagLine}>
            Investments
          </Typography>
        </Grid>
        {/* Title */}
        <Grid item>
          <Typography variant={isWidthUp('md', width) ? 'h3' : 'h4'} align="center" gutterBottom>
            Venture Capital on
            <div style={{fontWeight: 'bold'}}> your pocket.</div>
          </Typography>
        </Grid>
        {/* Image */}
        <Grid item>
          <object data={imagePath} className={classes.image}/>
        </Grid>
        {/* Mini Cards */}
        <Grid item className={classes.bottomTextContainer}>
          <Grid container direction="row" justify="center" alignItems="stretch" spacing={24}>
            <Grid item xs={12} sm={12} md={4}>
              <Grid container direction="row">
                <Grid item xs={2}>
                  <img src="/images/icons/investments/crypto-securities.svg" alt="Icon" className={classes.icon}/>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="h6">Crypto Securities</Typography>
                  <Typography variant="body2">Buy and Sell Securities using Cryptocurrency.</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Grid container direction="row">
                <Grid item xs={2}>
                  <img src="/images/icons/investments/create-and-subscribe-to-portfolio.svg" alt="Icon"
                       className={classes.icon}/>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="h6">Create & Subscribe to Portfolios</Typography>
                  <Typography variant="body2">
                    Build your investment portfolios and hedge funds from the listings. You can also subscribe to others
                    portfolios.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Grid container direction="row">
                <Grid item xs={2}>
                  <img src="/images/icons/investments/raise-funds.svg" alt="Icon" className={classes.icon}/>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="h6">Raise Funds</Typography>
                  <Typography variant="body2">
                    Get your business, project or cause funded on a decentralized network.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  </div>
));

export default withWidth()(Investments);
